/** Same rule as the API: only an explicit false is inactive. */
export const isEnterpriseActive = (organization) =>
  Boolean(organization) && organization.active !== false;

export const nextEnterpriseActive = (organization) =>
  !isEnterpriseActive(organization);
